/**
 * React Query Hook for fetching recommended tutors
 */

import { useQuery } from '@tanstack/react-query';
import { getRecommendedTutors } from '@/api/services/tutorsApi';
import type { GetRecommendedTutorsParams } from '@/types/api';

/**
 * Query hook for fetching recommended tutors with pagination
 * Uses TanStack Query with caching strategy
 * Cache key: ['recommendedTutors', params]
 */
export const useRecommendedTutors = (params?: GetRecommendedTutorsParams) => {
  return useQuery({
    queryKey: ['recommendedTutors', params],
    queryFn: async () => {
      return getRecommendedTutors(params);
    },
    retry: 1,
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 10, // 10 minutes (formerly cacheTime)
  });
};
